import { useWebInterface } from '../interface/web_interface';
import { useMemo } from 'react';

export const useIsDriver = () => {
	const { view } = useWebInterface();

	return useMemo(() => view === 'driver', [view]);
};
